import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import apiMethod from "../../services/api-service";
import methods from "../../services/utility";

import send from "../../assets/images/icons/send.svg";
import home from "../../assets/images/icons/home-hashtag.svg";
import calculator from "../../assets/images/icons/calculator.svg";

const WareHousesSidebar = () => {
  const { branchId, restaurantId } = useParams();
  const [logo, setLogo] = useState("");
  const branchInfo = async () => {
    const resp = await apiMethod.getBranchInfo(restaurantId);
    if (!methods.showApiErrors(resp)) return false;
    setLogo(resp.data.logo);
  };

  useEffect(() => {
    branchInfo();
  }, []);
  return (
    <div
      className="offcanvas-lg offcanvas-start"
      tabIndex="-1"
      id="sidebarMenu"
      aria-labelledby="sidebarMenuLabel"
    >
      <div className="offcanvas-header">
        <p className="offcanvas-title" id="sidebarMenuLabel"></p>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          data-bs-target="#sidebarMenu"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body d-lg-flex flex-column overflow-y-auto">
        <div className="text-center border-bottom">
          <img
            src={
              logo
                ? process.env.REACT_APP_ADMIN_PANEL_API + "/" + logo
                : methods.normalImage("", "logo")
            }
            className="img-fluid rounded-circle my-1"
            style={{ height: "100px" }}
          />
        </div>
        <Link to={`/sale/${branchId}`} className="link">
          <li className="list-group-item d-flex justify-content-between align-items-center px-2 py-3">
            <div>
              <i className="bi bi-bank fs-4"></i>
              <span className="px-2">فروش</span>
            </div>
            <div>
              <span className="badge sidebar-badge rounded-pill"></span>
              <span className="">
                <img src={send} alt="arrowLeft" />
              </span>
            </div>
          </li>
        </Link>
        <Link to="/accounting" className="link">
          <li className="list-group-item d-flex justify-content-between align-items-center px-2 py-3">
            <div>
              <img src={calculator} alt="calculator" />
              <span className="pe-1">حسابداری</span>
            </div>
            <div>
              <span className="badge sidebar-badge rounded-pill"></span>
              <span className="">
                <img src={send} alt="arrowLeft" />
              </span>
            </div>
          </li>
        </Link>
        <div className="accordion accordion-flush " id="accordionFlushExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                مدیریت انبار
              </button>
            </h2>
            <div
              id="flush-collapseOne"
              className="accordion-collapse collapse"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body p-0">
                <div className="list-group list-group-flush">
                  <Link
                    to={`/warehouse/${restaurantId}/createCategoryWarehouse`}
                    className="link list-group-item "
                  >
                    گروه انبار
                  </Link>
                  <Link
                    to={`/warehouse/${restaurantId}/createWarehouse`}
                    className="link list-group-item "
                  >
                    انبار
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WareHousesSidebar;
